<template>
  <!-- Demo Mode presence tell: a small muted square in the top-right corner,
       rendered only while Demo Mode is on. Unlabeled and innocuous to a viewer;
       the presenter knows it means masking is on. If it's gone, Demo Mode is
       off -- do not screen-share. -->
  <div class="demo-mode-tell" aria-hidden="true" data-testid="demo-indicator" :data-status="status" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DemoModePresenter',
  computed: {
    ...mapGetters('demoMode', ['status']),
  },
};
</script>

<style>
.demo-mode-tell {
  position: fixed;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background-color: #c8d2e0;
  opacity: 0.55;
  z-index: 2147483647;
  pointer-events: none;
}
</style>
